/**
 * Order service API
 *
 * Contact:
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveAdditionalFieldRequest {
    title?: string;
    name?: string;
    jsonSchema: object;
    required?: boolean;
    entityType: SaveAdditionalFieldRequest.EntityTypeEnum;
    filter?: boolean;
    separator?: boolean;
    sortOrder?: number;
    parentId?: number;
}
export namespace SaveAdditionalFieldRequest {
    export type EntityTypeEnum = 'ITEM' | 'ORDER' | 'USER' | 'COMPANY' | 'FINANCIAL_ITEM' | 'ARTICLE' | 'MERCHANT' | 'ITEM_CATEGORY' | 'COMMON_BUYER' | 'COMMON_SELLER' | 'CATEGORY' | 'TAG' | 'PARTNER' | 'ITEM_PHOTO' | 'BADGE' | 'ORDER_ITEM' | 'LEGAL_BUYER' | 'LEGAL_SELLER' | 'SKU' | 'SELLER_CATEGORY' | 'USER_REGION' | 'ARTICLE_CATEGORY' | 'PARTNER_PRODUCT' | 'FINANCIAL_ITEM_CATEGORY' | 'ORDER_PAYMENT' | 'PROMOCODE' | 'BRAND';
    export const EntityTypeEnum = {
        ITEM: 'ITEM' as EntityTypeEnum,
        ORDER: 'ORDER' as EntityTypeEnum,
        USER: 'USER' as EntityTypeEnum,
        COMPANY: 'COMPANY' as EntityTypeEnum,
        FINANCIAL_ITEM: 'FINANCIAL_ITEM' as EntityTypeEnum,
        ARTICLE: 'ARTICLE' as EntityTypeEnum,
        MERCHANT: 'MERCHANT' as EntityTypeEnum,
        ITEM_CATEGORY: 'ITEM_CATEGORY' as EntityTypeEnum,
        COMMON_BUYER: 'COMMON_BUYER' as EntityTypeEnum,
        COMMON_SELLER: 'COMMON_SELLER' as EntityTypeEnum,
        CATEGORY: 'CATEGORY' as EntityTypeEnum,
        TAG: 'TAG' as EntityTypeEnum,
        PARTNER: 'PARTNER' as EntityTypeEnum,
        ITEM_PHOTO: 'ITEM_PHOTO' as EntityTypeEnum,
        BADGE: 'BADGE' as EntityTypeEnum,
        ORDER_ITEM: 'ORDER_ITEM' as EntityTypeEnum,
        LEGAL_BUYER: 'LEGAL_BUYER' as EntityTypeEnum,
        LEGAL_SELLER: 'LEGAL_SELLER' as EntityTypeEnum,
        SKU: 'SKU' as EntityTypeEnum,
        SELLER_CATEGORY: 'SELLER_CATEGORY' as EntityTypeEnum,
        USER_REGION: 'USER_REGION' as EntityTypeEnum,
        ARTICLE_CATEGORY: 'ARTICLE_CATEGORY' as EntityTypeEnum,
        PARTNER_PRODUCT: 'PARTNER_PRODUCT' as EntityTypeEnum,
        FINANCIAL_ITEM_CATEGORY: 'FINANCIAL_ITEM_CATEGORY' as EntityTypeEnum,
        ORDER_PAYMENT: 'ORDER_PAYMENT' as EntityTypeEnum,
        PROMOCODE: 'PROMOCODE' as EntityTypeEnum,
        BRAND: 'BRAND' as EntityTypeEnum
    };
}


